module.exports = __webpack_public_path__ + "static/media/CTLA_4-178w.0448ba82.webp";